import { KYC_STATUS, type KycStatus } from '@/types/KycCompliance';
import type { AccessRolAction, AccessRolSection } from '../types/accessRol';
import { ACCESS_ROLE_ACTIONS, ACCESS_ROLE_SECTIONS } from './access.constant';

export const CARD_EXTERNAL_USER_ALLOWED_ROUTES = [
  'card',
  'card-details',
  'user-invitation',
  'onboarding-invitation',
];

export const OPEN_ONBOARDING_ALLOWED_ACTIONS: Partial<
  Record<AccessRolSection, AccessRolAction[]>
> = {
  [ACCESS_ROLE_SECTIONS.PROFILE]: [ACCESS_ROLE_ACTIONS.SECURITY],
};

export const FINISHED_REGISTRATION_KYC_STAGES: KycStatus[] = [
  KYC_STATUS.APPROVED,
  KYC_STATUS.UPLOADED_MANUAL,
  KYC_STATUS.REJECTED_MANUAL,
];
